import { Component, inject, Input } from '@angular/core';
import { faMinus, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { TunnelCartLine } from '../../../models/tunnel-cart-line';
import { TunnelCartService } from '../../../services/tunnel-cart.service';

/** Ligne compacte d'un produit retenu dans la liste d'achat. */
@Component({
  selector: 'ng-casto-tunnel-cart-item',
  templateUrl: './tunnel-cart-item.component.html',
  styleUrls: ['./tunnel-cart-item.component.scss'],
})
export class TunnelCartItemComponent {
  @Input() line: TunnelCartLine;

  protected readonly tunnelCartService = inject(TunnelCartService);

  protected readonly faMinus = faMinus;
  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;

  private static readonly PLACEHOLDER_IMAGE_SRC = 'assets/img/placeholders/item-list@2x.png';

  /** Source de l'image du produit, ou l'image par défaut. */
  protected get imageSource(): string {
    return this.line.imageSrc || TunnelCartItemComponent.PLACEHOLDER_IMAGE_SRC;
  }

  /** Prix total de la ligne. */
  protected get lineTotal(): number {
    return this.line.price * this.line.quantity;
  }

  /** Remplace l'image par l'image par défaut lorsque son chargement échoue. */
  protected setImageLoadError(event: Event): void {
    (event.target as HTMLImageElement).src = TunnelCartItemComponent.PLACEHOLDER_IMAGE_SRC;
  }

  protected changeQuantity(quantity: number): void {
    this.tunnelCartService.setQuantity(this.line.ean, quantity);
  }
}
